module.exports = __webpack_public_path__ + "img/window.56e7db2d.svg";